<div class="confirmation-dialog" [class.danger]="data.variant === 'danger'">
  <div class="dialog-content">
    <!-- Image/Logo -->
    <div class="dialog-icon">
      <img [src]="data.imagePath" alt="Dialog icon" class="icon-image" />
    </div>

    <!-- Main Message -->
    <h2 class="dialog-message">{{ data.message }}</h2>

    <!-- Optional Checkbox or Text -->
    <div class="checkbox-container" *ngIf="data.showCheckbox || data.checkboxText">
      <mat-checkbox *ngIf="data.showCheckbox" [(ngModel)]="checkboxChecked" color="primary">
        {{ data.checkboxText }}
      </mat-checkbox>
      <span *ngIf="!data.showCheckbox && data.checkboxText" class="checkbox-text-only">
        {{ data.checkboxText }}
      </span>
    </div>

    <!-- Action Buttons -->
    <div class="dialog-actions">
      <button mat-raised-button class="cancel-btn" (click)="onNoClick()">
        {{ data.cancelButtonText }}
      </button>
      <button mat-raised-button color="primary" class="confirm-btn" (click)="onYesClick()">
        {{ data.confirmButtonText }}
      </button>
    </div>
  </div>
</div>

